import { ReactComponent as MoreIcon } from 'assets/chat-more.svg';
import { ReactComponent as CheckAll } from 'assets/check-all.svg';
import { UploadChatFileIcon } from 'assets/icons';
import { ChatEntityType } from 'enums/chatEntityType';
import { FC, Fragment } from 'react';
import { DropDown } from 'ui/DropDown';
import { getDateWithTimezone } from 'utils/helpers';
import { UserAvatar } from './UserAvatar';
import { MessageProps } from './types';

export const Message: FC<MessageProps> = ({
  userId,
  content,
  created,
  files,
  state,
  currentUserId,
  entityType,
  timeZone,
}) => {
  const { members } = state;
  const messageClasses = {
    currentUser: {
      wrapper: 'justify-end mr-1',
      bg: 'bg-primary-60 rounded-t-lg rounded-bl-lg',
      time: 'justify-end',
      text: '!text-white',
    },
    anotherUser: {
      wrapper: 'gap-2',
      bg: 'bg-gray-light rounded-t-lg rounded-br-lg',
      time: 'justify-start',
      text: '!text-text-100',
    },
    systemUser: {
      wrapper: 'justify-center',
      bg: 'bg-primary-60 rounded-lg',
      time: 'justify-end',
      text: '!text-white',
    },
  };
  const index = members.findIndex((member) => member.userId === userId);
  const chatMember = members[index];
  const user = chatMember?.user;
  const isCurrentUserMessage = !!userId && !!currentUserId && +currentUserId === userId;
  const showAvatar = !isCurrentUserMessage;

  const bg = isCurrentUserMessage ? messageClasses.currentUser.bg : messageClasses.anotherUser.bg;
  const wrapper = isCurrentUserMessage
    ? messageClasses.currentUser.wrapper
    : messageClasses.anotherUser.wrapper;
  const time = isCurrentUserMessage
    ? messageClasses.currentUser.time
    : messageClasses.anotherUser.time;
  const text = isCurrentUserMessage
    ? messageClasses.currentUser.text
    : messageClasses.anotherUser.text;
  return (
    <>
      <div className={`message flex ${wrapper}`}>
        <UserAvatar user={user} showAvatar={showAvatar} />
        <div className={`p-2 ${bg} flex w-72 flex-col`}>
          <p className={`leading-cz mb-1 flex-1 break-all ${text} `}>
            {user && entityType === ChatEntityType.ModerationRequestChat && (
              <span className="mb-1 block">{user.firstName}</span>
            )}
            {content
              .trim()
              .split('\n')
              .map((str, index) => (
                <Fragment key={index}>
                  {str}
                  <br />
                </Fragment>
              ))}
            {files &&
              files.map((file) => {
                return (
                  <div
                    className="flex items-start justify-between gap-2 py-2"
                    key={file.downloadFileIdHash}
                  >
                    <div className="flex items-center gap-2">
                      <UploadChatFileIcon className="flex-shrink-0" />
                      <div>
                        <p className={`body-normal mb-1 ${text}`}>{file.fileName}</p>
                        <p className="callout-paragraphs-normal">
                          {file.fileName.split('.')[1].toUpperCase()}
                        </p>
                      </div>
                    </div>
                    <div>
                      <DropDown
                        buttonMode={false}
                        button={<MoreIcon className="ml-1 mt-2 cursor-pointer" />}
                        menuItems={[]}
                        file={file}
                      />
                    </div>
                  </div>
                );
              })}
          </p>
          <p>
            <span
              className={`flex ${time} leading-cz callout-paragraphs-normal items-end gap-0.5 ${text}`}
            >
              {getDateWithTimezone(created, timeZone, 'HH:mm')}
              {isCurrentUserMessage && <CheckAll />}
            </span>
          </p>
        </div>
      </div>
    </>
  );
};
